import React, { Fragment } from 'react';
import { Alert } from 'react-bootstrap';
import {
  setPassword,
  clearError,
} from '../../redux/authentication/authentication_actions';
import { connect } from 'react-redux';
import logoImage from '../../assets/images/2e-building.png';


class RegisterPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordRetype: '',
      validatingPassword: false,
      isShowSuccess: false,
    };
    this.handleBlurPassword = this.handleBlurPassword.bind(this);
  }

  onRegisterSubmit() {
    const {
      password,
      passwordRetype,
    } = this.state;

    if (!password || !passwordRetype) return;
    if (password !== passwordRetype) return;
    this.props.setPassword(password, this.props.token, this.props.uid);
  }

  onValueChange(event, fieldName) {
    this.setState({ ...this.state, [fieldName]: event.target.value });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isChangingPassword && !this.props.isChangingPassword && !this.props.errorMessage) {
      this.setState({ isShowSuccess: true });
    }
  }

  backToLogin() {
    this.props.history.push('/');
  }

  handleBlurPassword() {
    if (this.state.password.length > 0 && this.state.passwordRetype.length > 0) {
      this.setState({ validatingPassword: true });
    }
  }

  renderPasswordConfirmError() {
    if (this.state.validatingPassword && this.state.password !== this.state.passwordRetype && this.state.password != "" && this.state.passwordRetype != "") {
      return true;
    }
    return false;
  }

  componentDidMount() {
    this.props.clearError();
  }

  renderFormInputs() {
    const { isChangingPassword, errorMessage } = this.props;
    return (
      <Fragment>
        <div className="form-item js-form-item form-type-password js-form-type-password form-item-pass js-form-item-pass form-group">
          <label
            htmlFor="edit-pass"
            className="control-label js-form-required form-required"
          >
            Password *
          </label>
          <input
            className="form-text required form-control"
            id="edit-pass"
            name="pass"
            size="60"
            maxLength="128"
            type="password"
            value={this.state.password}
            onChange={event => this.onValueChange(event, 'password')}
            onBlur={this.handleBlurPassword}
            disabled={isChangingPassword}
            required
          />
        </div>

        <div className="form-item js-form-item form-type-password js-form-type-password form-item-pass js-form-item-pass form-group">
          <label
            htmlFor="edit-pass-retype"
            className="control-label js-form-required form-required"
          >
            Password (Re-type) *
          </label>
          <input
            className="form-text required form-control"
            id="edit-pass-retype"
            name="pass-retype"
            size="60"
            maxLength="128"
            type="password"
            value={this.state.passwordRetype}
            onChange={event => this.onValueChange(event, 'passwordRetype')}
            onBlur={this.handleBlurPassword}
            disabled={isChangingPassword}
            required
          />
        </div>

        {this.renderPasswordConfirmError() &&
          <div className="alert alert-danger" id="edit-password-not-match" >Passwords do not match</div>}

        {errorMessage && <div className="alert alert-danger" id="edit-invalid" >{errorMessage}</div>}

        <div
          className="form-actions form-group js-form-wrapper form-wrapper"
        >
          <button
            onClick={this.onRegisterSubmit.bind(this)}
            type="submit"
            className="button js-form-submit form-submit btn-primary btn icon-before"
            id="edit-submit"
            disabled={isChangingPassword || this.renderPasswordConfirmError()}
          >
            <span
              className="icon glyphicon glyphicon-log-in"
              aria-hidden="true"
            />
            {isChangingPassword ? 'Saving...' : 'Save'}
          </button>
        </div>
      </Fragment>
    );
  }

  renderSuccess() {
    return (
      <Alert bsStyle="info">
        {"Your new password has been save."}
      </Alert>
    );
  }

  render() {
    const { isShowSuccess } = this.state;

    return (
      <div className="zenregister scrollable-container">
        <div className="register-container">
          <div className="register-header">
            <img style={{ width: '100%' }} src={logoImage} />
            <a style={{ fontSize: 20, paddingTop: 10 }} href="#">Building Energy Code</a>
          </div>

          <div className="register-content">
            <form
              className="user-register-form"
              onSubmit={() => this.onRegisterSubmit()}
            >
              <div
                className="form-actions form-group js-form-wrapper form-wrapper"
              >
                <button
                  onClick={this.backToLogin.bind(this)}
                  type="button"
                  className="button btn icon-before"
                >
                  <span
                    className="icon glyphicon glyphicon glyphicon-menu-left"
                    aria-hidden="true"
                  />
                  Back to login
                </button>
              </div>

              {isShowSuccess ? this.renderSuccess() : this.renderFormInputs()}
            </form>
          </div>

          <div className="register-footer">
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  errorMessage: state.authentication.errorMessage,
  isChangingPassword: state.authentication.changingPwd,
});

const mapDispatchToProps = dispatch => ({
  setPassword: (...args) => dispatch(setPassword(...args)),
  clearError: (...args) => dispatch(clearError(...args)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RegisterPage);



// WEBPACK FOOTER //
// ./src/pages/request_reset_password/SetPasswordPage.js